import { zodToFormikSchema } from 'shared/form/ZodFormikAdapter';
import { Schema } from 'yup';
import { ZodType } from 'zod';

export type APISchema<TData> = Schema<TData> | ZodType<TData>;

export function castAPIData<TData>(
  schema: APISchema<TData>,
  data: unknown,
): TData {
  return isZodSchema(schema)
    ? zodToFormikSchema(schema).cast(data)
    : schema.cast(data);
}

function isZodSchema<TData>(
  schema: APISchema<TData>,
): schema is ZodType<TData> {
  return typeof (schema as ZodType).safeParse === 'function';
}
